import { Component, ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';
import { CommonModule, JsonPipe } from '@angular/common';
import { RtMapLayoutComponent } from './subcomponents/rt-map-layout/rt-map-layout.component';
import { RtMapCountersComponent } from './subcomponents/rt-map-counters/rt-map-counters.component';

interface CommandCenterExpressOverview {
  twoWheelsBookingCount: number;
  fourWheelsBookingCount: number;
  pending: {
    twoWheels: number;
    fourWheels: number;
  };
  ongoing: {
    twoWheels: number;
    fourWheels: number;
  };
  completed: {
    twoWheels: number;
    fourWheels: number;
  };
  cancelled: {
    twoWheels: number;
    fourWheels: number;
  };
}

@Component({
  selector: 'app-rt-map',
  standalone: true,
  imports:      [ CommonModule, RtMapLayoutComponent , RtMapCountersComponent],
  templateUrl: './rt-map.component.html',
  styleUrls: [
    './rt-map.component.scss',
    '../../../../assets/okito-comcenter/css/main.css',
    '../../../../assets/okito-comcenter/vendor/bootstrap/css/bootstrap.min.css',
    '../../../../assets/okito-comcenter/vendor/font-awesome/css/font-awesome.min.css'
  ],
  encapsulation: ViewEncapsulation.ShadowDom
})

export class RtMapComponent {
  date = new Date();
  
  constructor(
    
  ) { 
     // Update time every second
     setInterval(() => {
      this.date = new Date();
    }, 1000);
  }


  

  
}
